import {Filter} from './Filter'

/**
 * Allows you to filter products in the recommendation frame for products more expensive than the indicated price
 */
export class MinPriceFilter implements Filter {
    enableMultiple: boolean
    urlParam: string

    /** Filter value, product id to filter */
    value: string

    /** @param minPrice Minimal product price to filter */
    constructor(minPrice: string) {
        this.enableMultiple = false
        this.urlParam = 'filterpricemin'
        this.value = minPrice
    }
}